import React from 'react';

import { InvestmentStrategyDesktop } from './Desktop';
import { InvestmentStrategyMobile } from './Mobile';
import { InvestmentStrategyTypes } from './types';

export const InvestmentStrategy: React.FC<InvestmentStrategyTypes.Props> = ({ isMobile }) => {
  return isMobile ? <InvestmentStrategyMobile /> : <InvestmentStrategyDesktop />;
};
export { InvestmentStrategyListTypes } from './types';
